import {createAsyncThunk} from '@reduxjs/toolkit'
import {actions} from './slice'
import {
  FetchRemarqueByIdRequest,
  UpdateRemarqueRequest,
  FetchRemarquesRequest,
  CreateRemarqueRequest,
  DeleteRemarqueRequest,
  FetchAllRemarquesRequest,
  CheckRemarqueRequest,
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {Remarque} from '../../../models'
import axios from 'axios'
import {
  fetchRemarquesUrl,
  fetchRemarqueByIdUrl,
  createRemarqueUrl,
  updateRemarqueUrl,
  deleteRemarqueUrl,
  checkRemarqueUrl,
  fetchAllRemarquesUrl,
} from '../../api'

const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
  })
}

export const fetchRemarques = createAsyncThunk(
  'remarque/fetch',
  async (payload: FetchRemarquesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchRemarquesUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}&done=${
          payload.active
        }&teachers=${payload.teachers ? payload.teachers : ''}&classrooms=${
          payload.classrooms ? payload.classrooms : ''
        }&students=${payload.students ? payload.students : ''}&userId=${payload.userId}`
      )
      const {remarques, totalPages, total} = res.data
      return {
        remarques,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllRemarques = createAsyncThunk(
  'remarque/fetchAll',
  async (payload: FetchAllRemarquesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchAllRemarquesUrl}`)
      const {remarques} = res.data
      return {
        remarques,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchRemarqueById = createAsyncThunk(
  'remarque/fetchById',
  async (payload: FetchRemarqueByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchRemarqueByIdUrl}/${payload.id}`)
      const {remarque} = res.data
      return {
        remarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createRemarque = createAsyncThunk(
  'remarque/create',
  async (payload: CreateRemarqueRequest, {rejectWithValue, dispatch}) => {
    try {
      const data = new FormData()
      if (payload.type) data.append('type', payload.type)
      if (payload.deadline) data.append('deadline', payload.deadline)
      if (payload.classrooms) data.append('classrooms', JSON.stringify(payload.classrooms))
      if (payload.establishement) data.append('establishement', payload.establishement)
      if (payload.specificStudents)
        data.append('specificStudents', JSON.stringify(payload.specificStudents))
      if (payload.administration)
        data.append('administration', JSON.stringify(payload.administration))
      if (payload.toStudents) data.append('toStudents', JSON.stringify(payload.toStudents))
      if (payload.teacher) data.append('teacher', payload.teacher)
      if (payload.desc) data.append('desc', payload.desc)

      if (payload.attachements) {
        payload.attachements.forEach((file: any) => {
          if (file instanceof File) data.append('files', file)
        })
      }
      const res = await axios.post(createRemarqueUrl, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const {loaded, total} = progressEvent
          if (total) {
            const percentCompleted = Math.round((loaded * 100) / total)
            dispatch(actions.handleRequestProgress({progress: percentCompleted}))
          }

          //dispatch({ type: 'UPLOAD_PROGRESS', payload: percentCompleted });
        },
      })

      console.log('request received: ', res)
      const {remarque} = res.data
      return {
        remarque,
        success: true,
      }
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        error: JSON.stringify(error),
      })
    }
  }
)
/*

  id: string
  type: string
  desc: string
  establishement: string
  classrooms: string[]
  teacher?: string
  administration: boolean
  deadline: string
  specificStudents: boolean
  toStudents: string[]
  attachements?: string[]
*/

export const updateRemarque = createAsyncThunk(
  'remarque/update',
  async (payload: UpdateRemarqueRequest, {rejectWithValue}) => {
    try {
      const data = new FormData()
      if (payload.id) data.append('id', payload.id)
      if (payload.type) data.append('type', payload.type)
      if (payload.deadline) data.append('deadline', payload.deadline)
      if (payload.classrooms) data.append('classrooms', JSON.stringify(payload.classrooms))
      if (payload.establishement) data.append('establishement', payload.establishement)
      if (payload.specificStudents)
        data.append('specificStudents', JSON.stringify(payload.specificStudents))
      if (payload.administration)
        data.append('administration', JSON.stringify(payload.administration))
      if (payload.toStudents) data.append('toStudents', JSON.stringify(payload.toStudents))
      if (payload.teacher) data.append('teacher', payload.teacher)
      if (payload.desc) data.append('desc', payload.desc)
      if (payload.attachements) {
        payload.attachements.forEach((file: any) => {
          if (file instanceof File) data.append('files', file)
        })
      }
      if (payload.deletedAttachements) {
        data.append('deletedAttachements', JSON.stringify(payload.deletedAttachements))
      }
      const res = await axios.post(updateRemarqueUrl, data)
      const {remarque} = res.data
      return {
        remarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deleteRemarque = createAsyncThunk(
  'remarque/delete',
  async (payload: DeleteRemarqueRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deleteRemarqueUrl, payload)
      const {remarque} = res.data
      return {
        remarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const checkRemarque = createAsyncThunk(
  'remarque/check',
  async (payload: CheckRemarqueRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(checkRemarqueUrl, payload)
      const {remarque} = res.data
      return {
        remarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
